import useAuth from "../../../auth/useAuth";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { deleteExpenseById, getExpensesDateDriver, updateExpensesById } from "../../../config.js";

export const useExpenseManager = () => {

    const auth = useAuth();
    const token = auth.globals.token;

    const {
        showErrorRequest,
        alertSuccess
    } = Alerts();


    const getDetailExpensesByDateAndUser = async (date, user_driver) => {
        if (date && date !== "") {
            try {
                let res = await getExpensesDateDriver(token, date, user_driver);
                let data = await res.json()
                if (res.ok) {
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }

    const deleteExpensesFromUserById = async (expense_id) => {
        try {
            let res = await deleteExpenseById(expense_id, token);
            let data = await res.json()
            if (data.error) {
                showErrorRequest(data.message, auth)
            } else if (res.ok) {
                try {
                    alertSuccess("Eliminar Gasto", "El gasto fue eliminado con éxito", undefined);
                } catch {
                }
            } else {
                if (res.status === 401 || res.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                }
                showErrorRequest(data.detail, auth)
            }
            return res;
        } catch (errorRequest) {
        }
    }

    const updateExpenseByExpenseId = async (expenseId, body) => {
        if (body && expenseId !== "") {
            try {
                let res = await updateExpensesById(token, body, expenseId);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Editar Gasto", "El gasto se modifico correctamente", undefined)
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }


    return {
        //properties


        //methods
        getDetailExpensesByDateAndUser,
        deleteExpensesFromUserById,
        updateExpenseByExpenseId

    }
}